<script>
   /*************************************************************/
   /* PrepModal                                                 */
   /* -------------------------                                 */
   /* dialog with the creator and the plots, from PrepWidget    */
   /*************************************************************/

   import PrepCreator from './PrepCreator.svelte';
   import AppPlots from './AppPlots.svelte';

   // props from PrepWidget
   let {
      WASM,
      rawdata,
      prepobj = $bindable(),
      meta = $bindable(),
      finalize = null,
   } = $props();

   // the marker indices, the trim bounds and the short sets, local to the dialog. the creator sets
   // the bounds from the chain at its mount and at every committed edit, so a pair the widget kept
   // between openings was overwritten before the plots read it
   let varind = $state([-1, -1, -1]);
   let left = $state(0);
   let right = $state(0);
   let rawdataShort = $state.raw(null);
   let prepdataShort = $state.raw(null);

</script>

<div class="widget-container">

   <!-- left column with main app controls -->
   <div class="app-controls">
      <div class="prep-creator">
         <PrepCreator
            {WASM}
            {rawdata}
            bind:left={left}
            bind:right={right}
            bind:varind={varind}
            bind:prepobj={prepobj}
            bind:rawdataShort={rawdataShort}
            bind:prepdataShort={prepdataShort}
            bind:meta={meta}
            {finalize}
         />
      </div>
   </div>

   <!-- right column with help text or with plots and plot controls -->
   <div class="app-content">
      {#if rawdataShort}
      <AppPlots
         rawdata={rawdataShort}
         prepdata={prepdataShort}
         left={left}
         right={right}
         {varind}
         preview
      />
      {/if}
   </div>

</div>


<style>

   .widget-container {
      font-family: Helvetica, Arial, sans-serif;
      font-size: 1rem;
      color: #404040;
      box-sizing: border-box;
      margin: 0 auto;
      padding: 0.35em 0.25em;
      display: grid;
      grid-template-areas: "controls content";
      grid-template-rows: 100%;
      grid-template-columns: min(310px, 30%) 1fr;
      background-color: #606060;
      width: 98vw;
      height: 95vh;
   }

   .app-controls {
      box-sizing: border-box;
      padding: 0.25em 0.5em;
   }

   .app-content {
      box-sizing: border-box;
      padding: 0.25em 0.25em;
      height: 100%;
   }

   .app-controls > div {
      border-radius: 0.25rem;
   }

   @media(min-width:1100px) {
      .widget-container {
         grid-template-columns: min(320px, 30%) 1fr;
      }
   }

   @media(min-width:1300px) {
      .widget-container {
         grid-template-columns: min(340px, 30%) 1fr;
      }
   }

</style>